import axiosIns from './axios'

const utilsMixin = {
  methods: {
    /**
     * Formata um chassi (VIN) removendo caracteres inválidos
     * - Remove tudo que não seja A-Z ou 0-9
     * - Remove letras I, O e Q
     * - Retorna sempre em maiúsculas
     * @param {string} valor
     * @returns {string}
     */
    formatarChassi(valor) {
      if (!valor) return ''

      // Maiúsculo
      const formattedValor = valor.toUpperCase()
      console.log(formattedValor.replace(/[^A-HJ-NPR-Z0-9]/g, ''))

      // Remove caracteres inválidos (I, O, Q e tudo que não seja A-Z ou 0-9)
      return formattedValor.replace(/[^A-HJ-NPR-Z0-9]/g, '')
    },

    /**
     * Formata um RENAVAM para conter apenas dígitos (0-9)
     * @param {string} valor
     * @returns {string}
     */
    formatarRenavam(valor) {
      if (!valor) return ''

      // Remove tudo que não for dígito
      return valor.replace(/\D/g, '')
    },

    /**
      * Converts a currency string to a number in cents.
      * @param {string} value - The currency string to convert.
      * @returns {number} The converted number in cents.
     * */
    unformatCurrency(value) {
      if (!value) return 0

      let cleanedValue = value.replace(/\s|R\$/g, '')

      cleanedValue = cleanedValue.replace(',', '.')

      cleanedValue = cleanedValue.replace(/\.(?=\d{3})/g, '')

      const numberValue = Math.round(parseFloat(cleanedValue) * 100)

      return Number.isNaN(numberValue) ? 0 : numberValue
    },

    /**
     * Converts a number in cents to a formatted currency string.
     * @param {number|string} value - The number in cents to format.
     * @returns {string} The formatted currency string.
     * */
    formatCurrency(value) {
      if (!value && value !== 0) return ''

      const numericValue = typeof value === 'string' ? parseFloat(value.replace(/\D/g, '')) : value

      if (Number.isNaN(numericValue)) return ''

      const centavosValue = numericValue / 100

      return centavosValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },

    /**
     * Sends files to a specified API endpoint using a POST request.
     * @param {string} endpoint - The API endpoint to send the files to.
     * @param {File[]} files - An array containing file objects to be sent.
     * @param {Object} additionalData - An object containing any additional data to be sent in the request.
     */
    async sendFiles(endpoint, files, additionalData) {
      const formData = new FormData()

      files.forEach(file => {
        formData.append('files[]', file)
      })

      try {
        Object.keys(additionalData).forEach(key => {
          formData.append(key, additionalData[key])
        })
      } catch (error) {
        console.error(error.message)
      }

      await axiosIns
        .post(endpoint, formData)
        .then(() => {})
        .catch(error => {
          this.$swal({
            title: 'Erro ao enviar arquivos',
            text: `Contate a equipe de desenvolvimento ${error}`,
            icon: 'error',
            timer: 4000,
            showConfirmButton: false,
          })
        })
    },

    /**
     * Extracts the file extension from a string.
     * @param {string} fileName The name of the file to be processed.
     * @returns {string} The file extension, including the initial dot.
     */
    extractFileExtension(fileName) {
      const fileExtensionRegex = /\.[^/.]+$/g
      const matches = fileName.match(fileExtensionRegex)

      if (matches == null) {
        return fileName
      }

      return matches[0]
    },

    /**
     * Extracts all email addresses from a given text string and returns them
     * as a semicolon-separated string. Returns an empty string if no email addresses are found.
     * @param {string} text - The text string to search for email addresses.
     * @returns {string} A semicolon-separated string containing all email addresses found, or an empty string if none are found.
     */
    extractEmailsFromString(text) {
      // const emailRegex = /[\w.]+@\w+\.\w{2,3}(\.\w{2,3})/g // regex to find email addresses
      const emailRegex = /[\w.+]+@\w+\.\w{2,}(\.\w{2,})*/g // regex to find email addresses
      const foundEmails = text.match(emailRegex) // finds all email addresses in the string

      if (!foundEmails) return ''

      const joinedEmails = foundEmails.join(';') // joins the email addresses with semicolons

      return joinedEmails
    },

    /**
     * Removes accents from a string.
     * @param {string} str - The string to remove accents from.
     * @returns {string} The string without accents.
     */
    removeAccents(str) {
      if (typeof str !== 'string') return 'parameter is not of type string'

      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },

    /**
     * Checks if any key in the given object has a non-empty value.
     * @param {object} obj - The object to check.
     * @returns {boolean} - True if any key has a non-empty value, false otherwise.
     */
    hasNonEmptyKey(obj) {
      // eslint-disable-next-line no-restricted-syntax, no-unused-vars
      for (const [key, value] of Object.entries(obj)) {
        if (value !== '' && value) {
          return true
        }
      }

      return false
    },

    /**
     * Gera uma cor hexadecimal aleatória.
     * @returns {string} A cor gerada no formato hexadecimal.
     */
    generateRandomHexColor() {
      const MAX_COLOR_VALUE = 16777215
      const randomDecimal = Math.random() * MAX_COLOR_VALUE
      const roundedDecimal = Math.floor(randomDecimal)
      const hexValue = roundedDecimal.toString(16).padStart(6, '0')
      const hexColor = `#${hexValue}`

      return hexColor
    },

    /**
     * Returns a Portuguese human-readable string describing how much time is left
     * until a due date, or how long ago it expired.
     *
     * Example returns:
     * - "Vence em 10 dias"
     * - "Vence em 2 meses"
     * - "Vence em 1 ano"
     * - "Vencido há 3 dias"
     * - "Vencido há 1 ano"
     *
     * @param {string} currentDate - The current date in "yyyy-mm-dd" format.
     * @param {string} dueDate - The target due date in "yyyy-mm-dd" format.
     * @returns {string} A string in Portuguese describing time until or since due date.
     */
    getTimeUntilDue(currentDate, dueDate) {
      const current = new Date(currentDate)
      const due = new Date(dueDate)

      const diffInMs = due - current
      const isExpired = diffInMs < 0
      const referenceDate = isExpired ? current : due
      const targetDate = isExpired ? due : current

      const oneDay = 1000 * 60 * 60 * 24
      const totalDays = Math.floor(Math.abs(due - current) / oneDay)

      if (totalDays < 30) {
        const label = totalDays === 1 ? '1 dia' : `${totalDays} dias`

        return isExpired ? `Vencido há ${label}` : `Vence em ${label}`
      }

      const yearsDiff = referenceDate.getFullYear() - targetDate.getFullYear()
      const monthsDiff = referenceDate.getMonth() - targetDate.getMonth() + yearsDiff * 12

      if (monthsDiff < 12) {
        const label = monthsDiff === 1 ? '1 mês' : `${monthsDiff} meses`

        return isExpired ? `Vencido há ${label}` : `Vence em ${label}`
      }

      const label = yearsDiff === 1 ? '1 ano' : `${yearsDiff} anos`

      return isExpired ? `Vencido há ${label}` : `Vence em ${label}`
    },

    /**
     * Displays a confirmation dialog using SweetAlert2.
     * @param {string} title - The title of the confirmation dialog.
     * @param {string} text - The text content of the confirmation dialog.
     * @param {string} icon - The icon to display in the confirmation dialog.
     * @param {string} [confirmButtonText='Sim'] - The text for the confirm button.
     * @param {string} [cancelButtonText='Não'] - The text for the cancel button.
     * @param {boolean} [showCancelButton=true] - Whether to show the cancel button.
     * @param {string} [confirmButtonColor='#28a745'] - The color for the confirm button.
     * @param {string} [cancelButtonColor='#dc3545'] - The color for the cancel button.
     * @returns {Promise<boolean>} A promise that resolves to true if the user confirmed, false otherwise.
     */
    async confirmActionAlert(title, text, icon, confirmButtonText = 'Sim', cancelButtonText = 'Não', showCancelButton = true, confirmButtonColor = '#28a745', cancelButtonColor = '#dc3545') {
      const result = await this.$swal({
        title,
        text,
        icon,
        showCancelButton,
        confirmButtonColor,
        cancelButtonColor,
        confirmButtonText,
        cancelButtonText,
      })

      return result.isConfirmed
    },

  },
}

export default utilsMixin
